import BaseModelAPI from '../BaseModelAPI';

export default class PartPrice extends BaseModelAPI {
	static entity = 'partprice';
	static entityName = 'partprice';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.partId = '';
			this.part = {};
			this.partName = '';
			this.partPartNumber = '';
			this.partClassification = '';
			this.partVendor = '';
			this.startDate = '';
			this.endDate = '';
			this.vendorIdId = '';
			this.vendorId = {};
			this.priceProcess = 0;
			this.priceProduct = 0;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}